// extracted by mini-css-extract-plugin
module.exports = {"tabs":"terminal_tabs___A9cQ","closeIcon":"terminal_closeIcon__2SFFq","iframeWindow":"terminal_iframeWindow__qiitt","containerLeft":"terminal_containerLeft__Yu1Px"};